// extracted by mini-css-extract-plugin
export default {"footerCont":"FooterSection_footerCont__Q8tm1"};